import React from "react";
import mock01 from '../assets/images/mock01.png';
import mock02 from '../assets/images/mock02.png';
import mock03 from '../assets/images/mock03.png';
import mock04 from '../assets/images/mock04.png';
import mock05 from '../assets/images/mock05.png';
import mock06 from '../assets/images/mock06.png';
import mock07 from '../assets/images/mock07.png';
import mock08 from '../assets/images/mock08.png';
import mock09 from '../assets/images/mock09.png';
import mock10 from '../assets/images/mock10.png';
import mock011 from '../assets/images/mock011.png';
import mock12 from '../assets/images/mock12.png';
import mock13 from '../assets/images/mock13.png';
import mock14 from '../assets/images/mock14.png';
import mock15 from '../assets/images/mock15.png';
import mock16 from '../assets/images/mock16.jpg';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import Button from '@mui/material/Button';

import '../assets/styles/Project.scss';

function Project() {
    return(
    <div className="projects-container" id="projects">
        <h1>Projects</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://www.ixon.cloud/en/" target="_blank" rel="noreferrer"><img src={mock14} style={{ border: '2px solid #9400d3' }} className="zoom thumbnail-image" alt="thumbnail" width="100%"/></a>
                <a href="https://www.ixon.cloud/en/" target="_blank" rel="noreferrer"><h2>IXON Cloud Replica</h2></a>
                <p>PLC data communication system and web app for waste container interaction using Python, Django, AWS RDS/EC2, RealVNC. Implemented parallel programming for scalable KEP Server integration.</p>
            </div>

            <div className="project">
                <a href="https://github.com/HafizAhmadHassan/CompilerConstruction" target="_blank" rel="noreferrer"><img src={mock15} style={{ border: '2px solid #9400d3' }} className="zoom" alt="zoom" width="100%"/></a>
                <a href="https://github.com/HafizAhmadHassan/CompilerConstruction" target="_blank" rel="noreferrer"><h2>Compiler Implementation Using Java</h2></a>
                <p>Complete Compiler Construction Assignment Using JAVA Language</p>
            </div>

            <div className="project">
                <a href="https://github.com/HafizAhmadHassan/candy_crush" target="_blank" rel="noreferrer"><img src={mock16} style={{ border: '2px solid #9400d3' }} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/HafizAhmadHassan/candy_crush" target="_blank" rel="noreferrer"><h2>Candy Crush Game C++ OOP</h2></a>
                <p>A simplified version of the Candy Crush game developed using C++ and Object-Oriented Programming principles, featuring classes for the game board, candies, and matching logic to handle user moves, scoring, and candy swaps.</p>
            </div>

            <div className="project">
                <a href="https://github.com/HafizAhmadHassan/BIM-2" target="_blank" rel="noreferrer"><img src={mock011} style={{ border: '2px solid #9400d3' }} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/HafizAhmadHassan/BIM-2" target="_blank" rel="noreferrer"><h2>TBSS to study Fabry disease</h2></a>
                <p>Apply the Tract-based spatial statistics (TBSS) technique to investigate a group of subjects affected by the Fabry disease. TBSS is implemented in the FSL toolbox and, as a guidance, you can follow this tutorial. The goal is to study whether the Tract-based spatial statistics (TBSS) technique is able to differentiate the two groups of subjects (patients vs controls).</p>
            </div>

            <div className="project">
                <a href="https://github.com/HafizAhmadHassan/SaleManagementSystem" target="_blank" rel="noreferrer"><img src={mock12} style={{ border: '2px solid #9400d3' }} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/HafizAhmadHassan/SaleManagementSystem" target="_blank" rel="noreferrer"><h2>Sales Management System : Object Oriented Design & Analysis Project</h2></a>
                <p>This desktop application was developed as part of the Object-Oriented Analysis and Design course. The accompanying PDF files include design and analysis diagrams that illustrate the system's structure and development process.</p>
            </div>

            

            <div className="project">
                <a href="https://github.com/HafizAhmadHassan/Optimized-Timetable-Scheduling-Using-Genetic-Algorithm" target="_blank" rel="noreferrer"><img src={mock13} style={{ border: '2px solid #9400d3' }} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/HafizAhmadHassan/Optimized-Timetable-Scheduling-Using-Genetic-Algorithm" target="_blank" rel="noreferrer"><h2> Optimized Timetable Scheduling Using Genetic Algorithm</h2></a>
                <p>
                 This project generates a clash-free midterm exam timetable using a Genetic Algorithm, considering the following constraints:
                    <ul>
                        <li>Maximum 420 students per exam slot</li>
                        <li>No student has overlapping exams</li>
                        <li>No back-to-back exams for any student</li>
                    </ul>

                </p>

            </div>
            
        </div>
        <div>
           <Button
            variant="contained"
            
            href="https://github.com/hafizahmadhassan"
            target="_blank"
            rel="noreferrer"
            sx={{
                textTransform: 'none',
                backgroundColor: '#9400d3', // Purple background
                color: '#fff',              // White text
                mt: 2,
                '&:hover': {
                backgroundColor: '#9333ea', // Slightly deeper purple on hover
                color: '#fff',
                },
            }}
            >
            See More on GitHub
            </Button>


        </div>
    </div>
    );
}

export default Project;